import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "trigger", "overlay"]

  connect() {
    this.isOpen = false
    this.desktop = window.matchMedia("(min-width: 1024px)")
    this.onBreakpointChange = () => this.close(false)
    this.desktop.addEventListener("change", this.onBreakpointChange)
    this.sync()
  }

  disconnect() {
    this.desktop.removeEventListener("change", this.onBreakpointChange)
    document.body.style.overflow = this.originalOverflow || ""
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.originalOverflow = document.body.style.overflow
    this.isOpen = true
    this.sync()
    requestAnimationFrame(() => {
      if (this.isOpen) this.panelTarget.focus()
    })
  }

  close(returnFocus = true) {
    const wasOpen = this.isOpen
    this.isOpen = false
    this.sync()
    if (wasOpen && returnFocus && !this.desktop.matches) this.triggerTarget.focus()
  }

  sync() {
    const hidden = !this.desktop.matches && !this.isOpen
    this.panelTarget.classList.toggle("is-open", this.isOpen)
    this.panelTarget.toggleAttribute("inert", hidden)
    if (hidden) this.panelTarget.setAttribute("aria-hidden", "true")
    else this.panelTarget.removeAttribute("aria-hidden")
    this.triggerTarget.setAttribute("aria-expanded", String(this.isOpen))
    this.triggerTarget.setAttribute("aria-label", this.isOpen ? "Fermer le menu" : "Ouvrir le menu")
    this.overlayTarget.hidden = !this.isOpen || this.desktop.matches
    document.body.style.overflow = this.isOpen && !this.desktop.matches ? "hidden" : (this.originalOverflow || "")
  }

  handleKey(event) {
    if (!this.isOpen || this.desktop.matches) return
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    } else if (event.key === "Tab") {
      const links = Array.from(this.panelTarget.querySelectorAll("a, button"))
      const first = links[0]
      const last = links[links.length - 1]
      const outside = !this.panelTarget.contains(document.activeElement)
      if (event.shiftKey && (outside || document.activeElement === first || document.activeElement === this.panelTarget)) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && (outside || document.activeElement === last || document.activeElement === this.panelTarget)) {
        event.preventDefault()
        first.focus()
      }
    }
  }
}
